function updateMobileBadge(count) {
  const badge = document.getElementById("mobile-cart-badge");
  if (!badge) return;
  if (count > 0) {
    badge.textContent = count;
    badge.classList.remove("hidden");
    badge.classList.add("flex");
  } else {
    badge.classList.add("hidden");
    badge.classList.remove("flex");
  }
}

// Parse a Shopify cart remove link (/cart/change?line=1&quantity=0 or
// ?id=KEY&quantity=0) into a minimal payload. We must NOT post the whole
// cart form anymore — Zapiet's inputs live inside it now, and posting them
// to /cart/change corrupts the cart.
function parseRemoveLink(url) {
  try {
    const u = new URL(url, window.location.origin);
    const id = u.searchParams.get("id");
    const line = u.searchParams.get("line");
    if (id) return { id, quantity: 0 };
    if (line) return { line: parseInt(line, 10), quantity: 0 };
  } catch (e) {}
  return null;
}

class AccordionElement extends HTMLElement {
  constructor() {
    super();
    this.details = this.closest("details");
    this.summary = this.details.querySelector("summary");

    this._resetHeight();

    // Bind event handlers
    this.onClick = this.onClick.bind(this);
    this.onResize = this.onResize.bind(this);

    // bind onclick to summary element
    this.summary.addEventListener("click", this.onClick);

    // Listen for window resize event
    window.addEventListener("resize", this.onResize);
  }

  _open() {
    this.details.setAttribute("data-opening", "true");
    this.details.setAttribute("open", "true");

    this.details.style.height = `${
      this.summary.scrollHeight + this.scrollHeight
    }px`;
  }

  _resetHeight() {
    this.details.style.height = `${this.summary.scrollHeight}px`;
  }

  _close() {
    this.details.removeAttribute("data-opening");
    this.details.setAttribute("data-closing", "true");

    setTimeout(() => {
      this.details.removeAttribute("open");
      this.details.removeAttribute("data-closing");
    }, 300);

    this.details.style.height = `${this.summary.scrollHeight}px`;
  }

  onClick(e) {
    e.preventDefault();
    if (!this.details.open) {
      this._open();
    } else {
      this._close();
    }
  }

  onResize() {
    if (this.details.open) {
      this.details.style.height = `${
        this.summary.scrollHeight + this.scrollHeight
      }px`;
    } else {
      this._resetHeight();
    }
  }

  // Clean up event listener when element is removed from the DOM
  disconnectedCallback() {
    window.removeEventListener("resize", this.onResize);
  }
}

if (!customElements.get("accordion-element")) {
  customElements.define("accordion-element", AccordionElement);
}

class QuickAddToCart extends HTMLElement {
  constructor() {
    super();
    this.variantId = this.getAttribute("data-variant-id");
    this.onClick = this.onClick.bind(this);
    this.addEventListener("click", this.onClick);
  }

async onClick(e) {
  e.preventDefault();

  const link = e.target.closest("a");
  const url = link?.href;
  const cartItem = this.closest("cart-item");

  // 1. Optimistic DOM updates
  if (cartItem) cartItem.remove();

  const remainingItems = document.querySelectorAll("cart-item").length;
  if (remainingItems === 0) {
    const checkoutButtons = document.getElementById("checkout-buttons");
    if (checkoutButtons) checkoutButtons.style.display = "none";
    const cartHeader = document.getElementById("cart-header");
    if (cartHeader) cartHeader.classList.remove("border-b-[1.75px]", "border-black");
  }

  const anyCartItem = document.querySelector("cart-item");
  if (anyCartItem && typeof anyCartItem.updateCartTotal === "function") {
    anyCartItem.updateCartTotal();
  } else {
    const totalEl = document.getElementById("cart-total");
    const countEl = document.getElementById("cart-count");
    if (totalEl) totalEl.textContent = "$0";
    if (countEl) countEl.textContent = "0";
    const headerCart = document.querySelector("header-cart");
    if (headerCart?.setCount) headerCart.setCount(0);
  }

  // 2. Remove via minimal payload (never the whole cart form)
  const drawer = document.querySelector("cart-drawer");
  const payload = url ? parseRemoveLink(url) : null;
  await drawer.changeLine(payload);
}
}

if (!customElements.get("quick-add")) {
  customElements.define("quick-add", QuickAddToCart);
}

class SizeChart extends HTMLElement {
  constructor() {
    super();

    console.log("sizing....", this.getAttribute("data-size-chart"));

    const rawSizeChart = this.getAttribute("data-size-chart") || "[]";
    this.sizeChart = [];
    this.singleValue = null;

    try {
      const parsed = JSON.parse(rawSizeChart);
      if (Array.isArray(parsed)) {
        this.sizeChart = parsed;
      } else {
        this.singleValue = `${parsed}`.trim();
      }
    } catch (e) {
      this.singleValue = `${rawSizeChart}`.trim();
    }

    // Create a shadow DOM for encapsulation
    const shadow = this.attachShadow({ mode: "open" });

    // Apply styles and add the table to the shadow DOM
    const style = document.createElement("style");
style.textContent = `
  * {
    font-family: Century ATF Schoolbook BQ, Georgia, serif;
    font-style: normal;
    font-weight: 400;
    text-align: center;
  }

  :host {
    display: block;
    margin-top: 8px;
  }

  table {
    width: 100%;
    outline: 0;
    border-collapse: collapse;
    border: 1.25px solid #000;
  }

  @media (min-width: 768px) {
    table {
      border-width: 2px;
    }
  }

  th, td {
    font-size: 18px;
    padding: 12px 8px;
    border: 1.25px solid #000;
  }

  @media (min-width: 768px) {
    th, td {
      border-width: 2px;
    }
  }
`;
    // Generate the table and append it to the shadow DOM
    const content = this.singleValue
      ? this.generateSingleValue()
      : this.generateTable();
    shadow.appendChild(style);
    shadow.appendChild(content);
  }

  // Method to generate the table based on JSON data
  generateTable() {
    const table = document.createElement("table");

    // Create headers from the first item in the data array
    if (this.sizeChart.length > 0) {
      const headers = Object.values(this.sizeChart[0]);
      const thead = document.createElement("thead");
      thead.classList.add("table-header");

      const headerRow = document.createElement("tr");
      headers.forEach((headerText) => {
        const th = document.createElement("th");
        th.textContent = headerText;
        headerRow.appendChild(th);
      });

      thead.appendChild(headerRow);
      table.appendChild(thead);

      // Create table body with data
      const tbody = document.createElement("tbody");
      this.sizeChart.slice(1).forEach((rowData) => {
        const row = document.createElement("tr");

        Object.values(rowData).forEach((cellData) => {
          const cell = document.createElement("td");
          cell.textContent = cellData;

          const cellValue = `${cellData}`.trim();
          const isInteger = /^-?\d+$/.test(cellValue);
          const numericValue = parseInt(cellValue, 10);

          if (isInteger && numericValue >= 1 && numericValue <= 9) {
            cell.classList.add("text-gray-500");
          }

          row.appendChild(cell);
        });

        tbody.appendChild(row);
      });
      table.appendChild(tbody);
    }

    return table;
  }

  generateSingleValue() {
    const container = document.createElement("div");
    container.textContent = this.singleValue;

    const isInteger = /^-?\d+$/.test(this.singleValue);
    const numericValue = parseInt(this.singleValue, 10);

    if (isInteger && numericValue >= 1 && numericValue <= 9) {
      container.classList.add("text-gray-500");
    }

    return container;
  }
}

// Define the custom element if it's not already defined
if (!customElements.get("size-chart")) {
  customElements.define("size-chart", SizeChart);
}

class MobileMenu extends HTMLElement {
  constructor() {
    super();
    this.onClick = this.onClick.bind(this);

    this.openMenu = this.openMenu.bind(this);
    this.closeMenu = this.closeMenu.bind(this);
    // get the menu button
    this.menuButton = this.querySelector("button[id='menu-button']");
    this.mobileMenu = this.querySelector("nav[id='mobile-menu']");
    this.closeButton = this.querySelector("button[id='close']");
    this.menuBg = this.querySelector("div[id='bg-menu']");

    console.log(this.menuButton);

    // bind the click event

    this.closeButton.addEventListener("click", this.onClick);
    this.menuButton.addEventListener("click", this.onClick);
  }

  onClick(e) {
    e.preventDefault();

    if (this.hasAttribute("open")) {
      this.closeMenu();
    } else {
      this.openMenu();
    }
  }
  openMenu() {
    this.mobileMenu.setAttribute("open", "true");
    this.setAttribute("open", "true");
document.body.classList.add("overflow-hidden");
  }

  closeMenu() {
    this.removeAttribute("open");
    this.mobileMenu.removeAttribute("open");
    document.body.classList.remove("overflow-hidden");
  }
}

if (!customElements.get("mobile-menu")) {
  customElements.define("mobile-menu", MobileMenu);
}

class CartItem extends HTMLElement {
  constructor() {
    super();
    this.decreaseButton = this.querySelector("button[id='decrease']");
    this.increaseButton = this.querySelector("button[id='increase']");
    this.quantityEl = this.querySelector("p[id='quantity']");
    this.priceEl = this.querySelector("p[id='line-price']");
    this.quantity = parseInt(this.quantityEl?.innerHTML);
    this.unitPrice = parseInt(this.priceEl?.dataset.unitPrice || "0", 10);

    const rawMax = this.increaseButton?.dataset.max;
    this.maxQuantity = rawMax != null ? parseInt(rawMax, 10) : Infinity;

    // Prefer the line item key ({{ item.key }}) — it uniquely identifies
    // the line INCLUDING its properties (ZapietId, subscription data),
    // so quantity changes can never hit the wrong line. Falls back to
    // the old product id if the Liquid attr isn't present yet.
    this.pid =
      this.getAttribute("data-line-key") || this.getAttribute("data-product-id");
    this.handleQuantity = this.handleQuantity.bind(this);

    this._debounceTimer = null;

    if (this.decreaseButton)
      this.decreaseButton.addEventListener("click", this.handleQuantity);
    if (this.increaseButton)
      this.increaseButton.addEventListener("click", this.handleQuantity);

    this.updateButtonStates();
  }

  formatMoney(cents) {
    const amount = cents / 100;
    const hasDecimals = amount % 1 !== 0;
    return `$${hasDecimals ? amount.toFixed(2) : amount.toFixed(0)}`;
  }

  updateButtonStates() {
    if (this.decreaseButton) {
      this.decreaseButton.disabled = this.quantity <= 1;
    }
    if (this.increaseButton) {
      this.increaseButton.disabled = this.quantity >= this.maxQuantity;
    }
  }

  handleQuantity(e) {
    e.preventDefault();
    if (e.currentTarget.disabled) return;

    const id = e.currentTarget.id;

    let next = this.quantity;
    if (id === "decrease" && this.quantity > 1) next = this.quantity - 1;
    if (id === "increase" && this.quantity < this.maxQuantity) next = this.quantity + 1;
    if (next === this.quantity) return;

    this.quantity = next;
    this.quantityEl.textContent = next;
    if (this.priceEl) {
      this.priceEl.textContent = this.formatMoney(this.unitPrice * next);
    }

    this.updateButtonStates();
    this.updateCartTotal();

    clearTimeout(this._debounceTimer);
    this._debounceTimer = setTimeout(() => {
      document.querySelector("cart-drawer").updateQuantity(this.pid, this.quantity);
    }, 250);
  }

updateCartTotal() {
  const totalEl = document.getElementById("cart-total");
  const countEl = document.getElementById("cart-count");

  let total = 0;
  let count = 0;
  document.querySelectorAll("cart-item").forEach((item) => {
    const priceEl = item.querySelector("p[id='line-price']");
    const qtyEl = item.querySelector("p[id='quantity']");
    if (!priceEl || !qtyEl) return;
    const unit = parseInt(priceEl.dataset.unitPrice || "0", 10);
    const qty = parseInt(qtyEl.textContent, 10) || 0;
    total += unit * qty;
    count += qty;
  });

  if (totalEl) totalEl.textContent = this.formatMoney(total);
  if (countEl) countEl.textContent = count;
  updateMobileBadge(count); // ← add this
}
}

if (!customElements.get("cart-item")) {
  customElements.define("cart-item", CartItem);
}

class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.openDrawer = this.openDrawer.bind(this);
    this.update = this.update.bind(this);
    this.closeDrawer = this.closeDrawer.bind(this);
    this.onClick = this.onClick.bind(this);

    // ── Note persistence state ──────────────────────────────────────────
    this.bindNoteField = this.bindNoteField.bind(this);
    this.flushNoteSave = this.flushNoteSave.bind(this);
    this.enforceZapietVisibility = this.enforceZapietVisibility.bind(this);
    this.savedNote = null;
    this.pendingNote = null;
    this._noteTimer = null;

    // ── Serial mutation queue ───────────────────────────────────────────
    // Shopify's cart API loses writes under concurrent mutations (rapid
    // add/add or add/remove). Every cart request goes through enqueue()
    // so exactly one is in flight at a time.
    this._queue = Promise.resolve();
  }

  enqueue(fn) {
    this._queue = this._queue.then(fn, fn);
    return this._queue;
  }

  async connectedCallback() {
    this.freebieElements = this.querySelectorAll("#freebies div");
    document.addEventListener("click", this.onClick);

    await this.enqueue(() => this.clearFreebies());
    await this.update();

    // Add event listener for DOMContentLoaded to clear freebies on page load
    document.addEventListener(
      "DOMContentLoaded",
      this.clearFreebies.bind(this)
    );
  }

  disconnectedCallback() {
    document.removeEventListener("click", this.onClick);
  }

  enforceZapietVisibility() {
    const checkoutButtons = document.getElementById("checkout-buttons");
    const widget = document.getElementById("storePickupApp");
    if (!checkoutButtons || !widget) return;
    const enabled = checkoutButtons.dataset.zapietEnabled === "true";
    widget.classList.toggle("hidden", !enabled);
  }

  onClick(e) {
    if (e.target.id === "cart") {
      e.preventDefault();
      this.closeDrawer();
      return;
    }

    const closeBtn = e.target.closest("#close-cart, #close");
    if (closeBtn) {
      e.preventDefault();
      this.closeDrawer();
    }
  }

  // ── Note persistence ─────────────────────────────────────────────────
  bindNoteField() {
    const field = document.getElementById("cart-note-field");
    if (!field) return;

    // Seed state from whatever the server just rendered (i.e. cart.note)
    this.savedNote = field.value;
    this.pendingNote = field.value;

    field.addEventListener("input", () => {
      this.pendingNote = field.value;
      clearTimeout(this._noteTimer);
      this._noteTimer = setTimeout(() => this.flushNoteSave(), 500);
    });

    field.addEventListener("blur", () => this.flushNoteSave());
  }

  async flushNoteSave() {
    clearTimeout(this._noteTimer);
    if (this.pendingNote === null || this.pendingNote === this.savedNote) return;

    const noteToSave = this.pendingNote;
    try {
      await fetch("/cart/update.js", {
        method: "post",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ note: noteToSave }),
      });
      this.savedNote = noteToSave;
    } catch (err) {
      console.error("Note save failed:", err);
    }
  }

  // ── Shared renderer: swaps the drawer HTML while preserving the live
  // Zapiet widget, rebinds the note field, and reads the count straight
  // out of the rendered HTML (no extra cart.js fetch).
  //
  // Slide state note: `.is-open` lives on this host element, which is NOT
  // replaced here — only innerHTML is. The fresh #drawer-inner therefore
  // matches the `.is-open` CSS rule immediately at insertion and renders
  // already-slid-open, with no transition replay. No sync step required.
  renderDrawerHTML(htmlString) {
    const html = document.createElement("div");
    html.innerHTML = htmlString;

    const fresh = html.querySelector("#cart");
    const cartDrawer = document.getElementById("cart");
    if (!fresh || !cartDrawer) return;

    const freshCheckoutButtons = fresh.querySelector("#checkout-buttons");
    const nowEnabled = freshCheckoutButtons?.dataset.zapietEnabled === "true";

    // Zapiet only initializes its widget into #storePickupApp on a real page
    // load — it does not react to our AJAX-swapped HTML. So "live" here means
    // the current node actually has Zapiet-injected content, not just that
    // the placeholder div exists.
    const existingWidget = cartDrawer.querySelector("#storePickupApp");
    const widgetIsLive = !!(existingWidget && existingWidget.childElementCount > 0);

    cartDrawer.innerHTML = fresh.innerHTML;

    if (nowEnabled && widgetIsLive) {
      // Still eligible and already initialized — carry the live widget
      // across the swap so we don't lose Zapiet's in-progress state (e.g.
      // a delivery date the customer already picked).
      const placeholder = cartDrawer.querySelector("#storePickupApp");
      if (placeholder) placeholder.replaceWith(existingWidget);
    } else if (nowEnabled && !widgetIsLive && window.Zapiet?.start) {
      // Just became eligible and Zapiet has never mounted here. Zapiet
      // ships its own per-theme "cart just changed, re-render yourself"
      // hooks for Dawn/Prestige/etc (window.Zapiet.start(...) fired on
      // that theme's own cart-update event) — this custom theme has none
      // of those wired up, so we call the same entry point ourselves.
      // It does its own live /cart.js fetch and mounts straight into
      // #storePickupApp — no reload required.
      window.Zapiet.start(window.ZapietCachedSettings);
    }
    // If nowEnabled is false, we deliberately do NOT reattach a stale live
    // widget — doing so was leaving Zapiet's real (visible) node in the DOM
    // for a moment even when this cart is no longer eligible, which is what
    // caused the widget to flash on for non-local-delivery adds.

    // Re-bind the note field since innerHTML above just replaced it
    this.bindNoteField();
    this.enforceZapietVisibility();

    const countEl = cartDrawer.querySelector("#cart-count");
    const count = countEl ? parseInt(countEl.textContent, 10) || 0 : 0;
    this.updateHeaderCartCount(count);
  }

  async update() {
    return this.enqueue(async () => {
      // Flush any unsaved note BEFORE re-fetching the section, so the fresh
      // server-rendered HTML reflects the note the customer just typed
      // instead of stomping it with a stale cart.note.
      await this.flushNoteSave();

      const visibleItems = document.querySelectorAll("cart-item").length;
      if (visibleItems > 0) {
        await this.updateFreeItems();
      }

      const res = await fetch("/?section_id=cart-drawer");
      const text = await res.text();
      this.renderDrawerHTML(text);
    });
  }

  async updateHeaderCartCount(count) {
    // Mobile badge
    const badge = document.getElementById("mobile-cart-badge");
    if (badge) {
      if (count > 0) {
        badge.textContent = count;
        badge.classList.remove("hidden");
        badge.classList.add("flex");
      } else {
        badge.classList.add("hidden");
        badge.classList.remove("flex");
      }
    }

    // Desktop header-cart instances
    document.querySelectorAll("header-cart").forEach(el => {
      if (typeof el.setCount === "function") el.setCount(count);
    });
  }

  async updateFreeItems() {
    if (this.freebieElements.length === 0) {
      return;
    }

    const res = await fetch("/cart.js");
    const cart = await res.json();

    for (const element of this.freebieElements) {
      const threshold = parseInt(element.getAttribute("data-threshold"), 10);
      const productId = parseInt(element.getAttribute("data-product-id"), 10);
      const freebieItem = cart.items.find((item) => item.id === productId);

      if (cart.total_price < threshold * 100) {
        // Remove the freebie from the cart if it's there
        if (freebieItem) {
          await fetch("/cart/change.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              id: freebieItem.key,
              quantity: 0,
            }),
          });
        }
      } else {
        // Add the freebie to the cart if it's not already there
        if (!freebieItem) {
          await this.addFreebieRaw(productId);
        }
      }
    }
  }

  // Raw add used inside the queue by updateFreeItems (must not re-enqueue)
  async addFreebieRaw(productId) {
    await fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "post",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        items: [
          { id: productId, quantity: 1, properties: { _promo: "Freebie" } },
        ],
      }),
    }).catch((error) => {
      console.error("Error:", error);
    });
  }

  // Quantity changes and removes: one request carries the mutation AND the
  // fresh drawer HTML (sections param) — no separate refetch round-trip.
  async updateQuantity(itemId, quantity) {
    return this.enqueue(async () => {
      try {
        const res = await fetch("/cart/change.js", {
          method: "post",
          keepalive: true,
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            id: itemId,
            quantity: quantity,
            sections: "cart-drawer",
          }),
        });
        const data = await res.json().catch(() => null);
        if (!res.ok) {
          console.error("[Cart] change:", data?.description || data?.message || res.status);
        }
        if (data?.sections?.["cart-drawer"]) {
          this.renderDrawerHTML(data.sections["cart-drawer"]);
          return;
        }
      } catch (err) {
        console.error("[Cart] change:", err);
      }
      const res = await fetch("/?section_id=cart-drawer");
      this.renderDrawerHTML(await res.text());
    });
  }

  // Minimal remove — payload is {id|line, quantity: 0} parsed from the
  // remove link. Never post the cart form (it contains Zapiet's inputs).
  async changeLine(payload) {
    return this.enqueue(async () => {
      if (payload) {
        try {
          const res = await fetch("/cart/change.js", {
            method: "post",
            keepalive: true,
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ ...payload, sections: "cart-drawer" }),
          });
          const data = await res.json().catch(() => null);
          if (!res.ok) {
            console.error("[Cart] remove:", data?.description || data?.message || res.status);
          }
          if (data?.sections?.["cart-drawer"]) {
            this.renderDrawerHTML(data.sections["cart-drawer"]);
            return;
          }
        } catch (err) {
          console.error("[Cart] remove:", err);
        }
      }
      const res = await fetch("/?section_id=cart-drawer");
      this.renderDrawerHTML(await res.text());
    });
  }

  async addProductToCart(itemId, freeItem = false) {
    console.log("adding product to cart", itemId);
    return this.enqueue(async () => {
      await fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "post",
        keepalive: true,
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          items: [
            {
              id: itemId,
              quantity: 1,
              properties: freeItem ? { _promo: "Freebie" } : {},
            },
          ],
          sections: "cart-drawer",
        }),
      })
        .then(async (res) => {
          const data = await res.json().catch(() => null);
          if (data?.sections?.["cart-drawer"]) {
            this.renderDrawerHTML(data.sections["cart-drawer"]);
          } else {
            const r = await fetch("/?section_id=cart-drawer");
            this.renderDrawerHTML(await r.text());
          }
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    });
  }

  // Used by the subscription (local-delivery-form) add flow — a JSON add
  // with a selling_plan. Routed through enqueue() like every other cart
  // mutation: Shopify's cart API silently drops one write when two requests
  // land concurrently, and this was the one add path firing an unqueued
  // fetch of its own, outside the shared queue every other mutation uses.
  async addSubscription(payload) {
    return this.enqueue(async () => {
      try {
        const res = await fetch("/cart/add.js", {
          method: "post",
          keepalive: true,
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
          },
          body: JSON.stringify(payload),
        });
        const data = await res.json().catch(() => null);

        if (!res.ok) {
          return { ok: false, data };
        }

        if (data?.sections?.["cart-drawer"]) {
          this.renderDrawerHTML(data.sections["cart-drawer"]);
        } else {
          const r = await fetch("/?section_id=cart-drawer");
          this.renderDrawerHTML(await r.text());
        }

        this.openDrawer();
        return { ok: true, data };
      } catch (error) {
        return { ok: false, error };
      }
    });
  }

  async addToCart(form) {
    return this.enqueue(async () => {
      try {
        const fd = new FormData(form);
        fd.set("sections", "cart-drawer");

        const res = await fetch("/cart/add.js", {
          method: "post",
          keepalive: true,
          body: fd,
        });
        const data = await res.json().catch(() => null);

        if (res.status === 429) {
          // Shopify throttle — wait and retry once
          await new Promise((r) => setTimeout(r, 2500));
          const retry = await fetch("/cart/add.js", { method: "post", keepalive: true, body: fd });
          const retryData = await retry.json().catch(() => null);
          if (retry.ok && retryData?.sections?.["cart-drawer"]) {
            this.renderDrawerHTML(retryData.sections["cart-drawer"]);
            this.openDrawer();
            return true;
          }
          console.error("[Cart] add: rate limited");
        } else if (!res.ok) {
          console.error("[Cart] add:", data?.description || data?.message || res.status);
        }

        // Render FIRST, then open — no empty-cart flash.
        if (data?.sections?.["cart-drawer"]) {
          this.renderDrawerHTML(data.sections["cart-drawer"]);
        } else {
          const r = await fetch("/?section_id=cart-drawer");
          this.renderDrawerHTML(await r.text());
        }

        this.openDrawer();
        return res.ok;
      } catch (error) {
        console.error("Error:", error);
        const r = await fetch("/?section_id=cart-drawer");
        this.renderDrawerHTML(await r.text());
        this.openDrawer();
        return false;
      }
    });
  }

  // looks for a freebie in cart, and removes any
  async clearFreebies({ route = true } = {}) {
    const res = await fetch("/cart.js");
    const cart = await res.json();

    let updates = {};

    // goes through the cart items and collects freebies
    cart.items.forEach((item) => {
      if (item.properties && item.properties._promo === "Freebie") {
        updates[item.key] = 0;
      }
      if (route && item.vendor === "Route") {
        updates[item.key] = 0;
        console.log("route!");
      }
    });

    if (Object.keys(updates).length === 0) return;

    // removes the freebies from the cart
    await fetch("/cart/update.js", {
      method: "post",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        updates: updates,
      }),
    }).catch((error) => {
      console.error("Error:", error);
    });
  }

  async addFreebiesToCart(itemIds, discountCode) {
    try {
      // 1. Clear existing freebies
      await this.enqueue(() => this.clearFreebies({ route: false }));

      // 2. Add new freebies
      await this.enqueue(() =>
        fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            items: itemIds.map((id) => ({
              id: id,
              quantity: 1,
              properties: { _promo: "Freebie" },
            })),
          }),
        })
      );

      // 3. Apply discount via AJAX
      if (discountCode) {
        const discountResponse = await fetch("/cart/update.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            discount: discountCode,
          }),
        });

        const discountData = await discountResponse.json();
        if (discountData && discountData.items) {
          console.log("Discount applied:", discountCode, discountData);
        } else {
          console.warn("Discount could not be applied");
        }
      }

      // 4. Redirect to checkout

      window.location.href = `/checkout`;
    } catch (error) {
      console.error("Error in addFreebiesToCart:", error);
    }
  }

  openDrawer() {
    document.getElementById("freebie-select-screen").style.display = "none";

    this.setAttribute("open", "true");
    this.style.pointerEvents = "auto";

    // Force a style flush before toggling the class: if the drawer was just
    // (re)rendered this frame, the browser needs to have committed the
    // -translate-y-full state once, or the slide-in won't animate.
    const inner = this.querySelector("#drawer-inner");
    if (inner && !this.classList.contains("is-open")) {
      void inner.offsetHeight;
    }

    this.classList.add("is-open");
  }

  async closeDrawer() {
    this.removeAttribute("open");
    this.style.pointerEvents = "none";
    this.classList.remove("is-open");

    this.enqueue(() => this.flushNoteSave());
  }
}

if (!customElements.get("cart-drawer")) {
  customElements.define("cart-drawer", CartDrawer);
}

class AddToCart extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector("button[id='atc']");
    this.quickCheckout = this.querySelector("button[id='quick-checkout']");
    this.onClick = this.onClick.bind(this);
    this.onClickQuickCheckout = this.onClickQuickCheckout.bind(this);

    if (this.quickCheckout)
      this.quickCheckout.addEventListener("click", this.onClickQuickCheckout);

    this.button.addEventListener("click", this.onClick);

    this.variants = this.querySelectorAll("div[id='variant']");
    this.setInitialVariant();
    this.activeVariant = this.activeVariant.bind(this);
    this.variants.forEach((variant) => {
      variant.addEventListener("click", (e) => this.activeVariant(e));
    });
  }

  setInitialVariant() {
    const activeVariant = this.querySelector("input[id='selected-variant-id']");
    this.variants.forEach((variant) => {
      if (variant.getAttribute("data-variant-id") === activeVariant.value) {
        variant.classList.add("selected");
      }
    });
  }

  async activeVariant(e) {
    const activeVariant = this.querySelector("input[id='selected-variant-id']");
    this.variants.forEach((v) => v.classList.remove("selected"));
    e.target.classList.add("selected");
    activeVariant.value = e.target.getAttribute("data-variant-id");
  }

  async onClickQuickCheckout(e) {
    e.preventDefault();
    const activeVariant = parseInt(
      this.querySelector("#selected-variant-id").value,
      10
    );
    // /cart/{variant}:1 permalinks REPLACE the whole cart — never use them.
    try {
      await fetch("/cart/add.js", {
        method: "post",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: [{ id: activeVariant, quantity: 1 }] }),
      });
      window.location.href = "/checkout";
    } catch (err) {
      console.error("Quick checkout failed:", err);
    }
  }
async onClick(e) {
  e.preventDefault();
  const form = this.closest("form");

    // ── Stock gate: re-fetch cart right before adding ──────────────────────
    // NOTE: only applies to inventory-tracked variants. Render
    // data-inventory EMPTY in Liquid when tracking is off:
    // data-inventory="{% if variant.inventory_management == 'shopify' %}{{ variant.inventory_quantity }}{% endif %}"
    // Empty parses to 0 → gate skipped → stock is irrelevant, per client.
    const atcBtn    = this.querySelector("button[id='atc']");
    const variantId = parseInt(this.querySelector("#selected-variant-id")?.value || "0", 10);
    const stock     = parseInt(atcBtn?.getAttribute("data-inventory") || "0", 10);
    const qtyInput  = this.querySelector("#quantity-input");
    const requested = parseInt(qtyInput?.value || "1", 10);

    if (stock > 0 && variantId) {
      try {
        const cartRes  = await fetch("/cart.js");
        const cart     = await cartRes.json();
        const inCart   = cart.items
          .filter((i) => i.variant_id === variantId)
          .reduce((sum, i) => sum + i.quantity, 0);

        const remaining = stock - inCart;

        if (remaining <= 0) {
          // Already at stock limit — update UI and bail
          const atcText = this.querySelector("[data-atc-text]");
          if (atcText) atcText.textContent = "Max Quantity Reached";
          if (atcBtn)  atcBtn.disabled = true;
          // Trigger a UI refresh on the form
          const productForm = this.querySelector("[data-product-form]");
          if (productForm?.__resetQty) productForm.__resetQty();
          return;
        }

        // Clamp the quantity to what's actually available
        if (requested > remaining && qtyInput) {
          qtyInput.value = remaining;
        }
      } catch (err) {
        console.error("Stock check failed:", err);
        // Allow the add to proceed if the check fails — Shopify will enforce on its end
      }
    }
    // ── End stock gate ─────────────────────────────────────────────────────

    // Loading state
    const loader = this.querySelector("span[id='loading']");
    const active = this.querySelector("span[id='active']");
    if (loader) {
      loader.classList.remove("hidden");
      active?.classList.add("hidden");
    }

    const ok = await document.querySelector("cart-drawer").addToCart(form);


    if (loader) {
      loader.classList.add("hidden");
      active?.classList.remove("hidden");
    }


    const productForm = this.querySelector("[data-product-form]");
    if (productForm?.__resetQty) productForm.__resetQty();
  }
}

if (!customElements.get("cart-add")) {
  customElements.define("cart-add", AddToCart);
}

class HeaderCart extends HTMLElement {
  constructor() {
    super();
    this.countEl = this.querySelector("[data-cart-count]");
    this.cartIcon = this.querySelector(".cart-icon");
    this.closeIcon = this.querySelector(".close-icon");
    this.onClick = this.onClick.bind(this);
    this.updateIcon = this.updateIcon.bind(this);
    this.addEventListener("click", this.onClick);
  }



updateIcon() {
  if (!this.cartIcon || !this.closeIcon) return;
  const isOpen = this.cart.hasAttribute("open");
  this.cartIcon.classList.toggle("hidden", isOpen);
  this.closeIcon.classList.toggle("hidden", !isOpen);
}

setCount(count) {

  if (this.countEl) {
    const normalizedCount = Number.isNaN(parseInt(count, 10)) ? 0 : count;
    this.countEl.textContent = `(${normalizedCount})`;
  }


  const badge = document.getElementById('mobile-cart-badge');
  if (!badge) return;
  const n = parseInt(count, 10) || 0;
  if (n > 0) {
    badge.textContent = n;
    badge.classList.remove('hidden');
    badge.classList.add('flex');
  } else {
    badge.classList.add('hidden');
    badge.classList.remove('flex');
  }
}
  onClick(e) {
    e.preventDefault();
    const cartDrawer = document.querySelector("cart-drawer");
    if (cartDrawer.hasAttribute("open")) {
      cartDrawer.closeDrawer();
    } else {
      cartDrawer.openDrawer();
    }
  }
}

if (!customElements.get("header-cart")) {
  customElements.define("header-cart", HeaderCart);
}

class RemoveButton extends HTMLElement {
  constructor() {
    super();
    this.onClick = this.onClick.bind(this);
    this.addEventListener("click", this.onClick);
  }

  async onClick(e) {
    e.preventDefault();

    const link = e.target.closest("a");
    const url = link?.href;
    const cartItem = this.closest("cart-item");

    // 1. Optimistically remove the item from DOM
    if (cartItem) {
      cartItem.remove();
    }

    // 2. Update cart total and count immediately
    const anyCartItem = document.querySelector("cart-item");
    if (anyCartItem && typeof anyCartItem.updateCartTotal === "function") {
      anyCartItem.updateCartTotal();
    } else {
      // No items left — zero out the totals manually
      const totalEl = document.getElementById("cart-total");
      const countEl = document.getElementById("cart-count");
      if (totalEl) totalEl.textContent = "$0";
      if (countEl) countEl.textContent = "0";
      const headerCart = document.querySelector("header-cart");
      if (headerCart?.setCount) headerCart.setCount(0);
    }

    // 3. Remove via minimal payload (never the whole cart form —
    // Zapiet's inputs live inside it and corrupt the cart)
    const drawer = document.querySelector("cart-drawer");
    const payload = url ? parseRemoveLink(url) : null;
    await drawer.changeLine(payload);
  }
}
if (!customElements.get("remove-button")) {
  customElements.define("remove-button", RemoveButton);
}

class Newsletter extends HTMLElement {
  constructor() {
    super();
    // elements are input with id email, button with id subscribe
    this.email = this.querySelector("input[id='email']");
    this.button = this.querySelector("button[id='subscribe']");
    this.onClick = this.onClick.bind(this);
    console.log(this.button);

    // if ?customer_posted=true#contact_form is in the url, show a success message
    const urlParams = new URLSearchParams(window.location.search);
    const customerPosted = urlParams.get("customer_posted");
    if (customerPosted === "true") {
      this.changeStatus("Thank you for subscribing");
    }
    this.button.addEventListener("click", this.onClick);
  }
async onClick(e) {
  e.preventDefault();

  const link = e.target.closest("a");
  const url = link?.href;
  const cartItem = this.closest("cart-item");

  // 1. Optimistically remove the item from DOM
  if (cartItem) {
    cartItem.remove();
  }

  // 2. If that was the last item, hide the checkout button immediately
  const remainingItems = document.querySelectorAll("cart-item").length;
  if (remainingItems === 0) {
    const checkoutButtons = document.getElementById("checkout-buttons");
    if (checkoutButtons) checkoutButtons.style.display = "none";
  }

  // 3. Update cart total and count
  const anyCartItem = document.querySelector("cart-item");
  if (anyCartItem && typeof anyCartItem.updateCartTotal === "function") {
    anyCartItem.updateCartTotal();
  } else {
    const totalEl = document.getElementById("cart-total");
    const countEl = document.getElementById("cart-count");
    if (totalEl) totalEl.textContent = "$0";
    if (countEl) countEl.textContent = "0";
    const headerCart = document.querySelector("header-cart");
    if (headerCart?.setCount) headerCart.setCount(0);
  }

  // 4. Also remove the border under "Cart (0)" since cart is now empty
  if (remainingItems === 0) {
    const cartHeader = document.querySelector("#drawer > div:first-child");
    if (cartHeader) {
      cartHeader.classList.remove("border-b-[1.75px]", "border-black");
    }
  }

  // 5. Remove via minimal payload (never the whole cart form)
  const drawer = document.querySelector("cart-drawer");
  const payload = url ? parseRemoveLink(url) : null;
  await drawer.changeLine(payload);
}

  async changeStatus(text) {
    this.querySelector("p").textContent = text;
  }
}

if (!customElements.get("newsletter")) {
  customElements.define("newsletter-widget", Newsletter);
}

class SlideShow extends HTMLElement {
  constructor() {
    super();
    this.initSwiper();
  }

  initSwiper() {
    // Make sure Swiper only initializes when the swiper-container is present
    const swiperContainer = this;
    console.log(swiperContainer);
    if (swiperContainer) {
      const swiper = new Swiper(".swiper", {
        // Swiper options
        slidesPerView: 1, // Number of slides to show
        spaceBetween: 0, // Space between slides
        speed: 400,
        on: {
          init: this.updateProgressBar.bind(this), // Reference to class method
          slideChange: this.updateProgressBar.bind(this), // Reference to class method
        },
      });
      console.log(swiper);
    }
  }
  updateProgressBar() {
    this.querySelector("div[id='progress']").style.width = `${
      ((this.swiper.activeIndex + 1) / this.swiper.slides.length) * 100
    }%`;

    console.log(this.swiper.activeIndex + 1, this.swiper.slides.length);
  }
}

if (!customElements.get("product-slideshow")) {
  customElements.define("product-slideshow", SlideShow);
}

class SearchWidget extends HTMLElement {
  constructor() {
    super();
    this.searchPlaceholder = this.querySelector("#search-placeholder");
    this.searchInput = this.querySelector("#search");

    // Bind the event handlers
    this.toggleSearch = this.toggleSearch.bind(this);
    this.executeSearch = this.executeSearch.bind(this);

    // Click to show search input
    this.searchPlaceholder.addEventListener("click", this.toggleSearch);

    // Listen for Enter key in the input field
    this.searchInput.addEventListener("keydown", this.executeSearch);
  }

  toggleSearch() {
    this.searchPlaceholder.classList.add("hidden");
    this.searchInput.classList.remove("hidden");
    this.searchInput.focus();
  }

  executeSearch(event) {
    if (event.key === "Enter") {
      event.preventDefault();
      const query = this.searchInput.value.trim();

      if (query.length > 0) {
        // Redirect to the Shopify search page with the search query
        window.location.href = `/search?q=${encodeURIComponent(
          query
        )}&type=product`;
      }
    }
  }
}

// Define the custom element
if (!customElements.get("search-widget")) {
  customElements.define("search-widget", SearchWidget);
}
class MenuSearchWidget extends HTMLElement {
  constructor() {
    super();

    this.placeholder = this.querySelector("#menu-search-placeholder");
    this.input = this.querySelector("#menu-search");

    if (!this.placeholder || !this.input) return;

    this.toggleSearch = this.toggleSearch.bind(this);
    this.executeSearch = this.executeSearch.bind(this);

    this.placeholder.addEventListener("click", this.toggleSearch);
    this.input.addEventListener("keydown", this.executeSearch);
  }

  toggleSearch() {
    this.placeholder.classList.add("hidden");
    this.input.classList.remove("hidden");
    this.input.focus();
  }

  executeSearch(e) {
    if (e.key === "Enter") {
      e.preventDefault();
      const query = this.input.value.trim();
      if (!query) return;

      window.location.href = `/search?q=${encodeURIComponent(query)}&type=product`;
    }
  }
}

if (!customElements.get("menu-search-widget")) {
  customElements.define("menu-search-widget", MenuSearchWidget);
}